(() => {
  const init = () => {
    if (document.documentElement.dataset.zeMobileShopping) return;
    document.documentElement.dataset.zeMobileShopping = 'true';
    const mobile = window.matchMedia('(max-width:749px)');
    const moves = [];
    const move = (node, after) => {
      if (!node || !after) return;
      const marker = document.createComment('');
      node.before(marker);
      moves.push({node, marker, after});
    };
    move(document.querySelector('#zen-best-sellers'), document.querySelector('.ze-hero'));
    const buy = document.querySelector('.pdp2-buy,.elite2-buy,.c2hero-buy');
    if (buy) {
      move(document.querySelector('.pdp2-gallery-facts,.elite2-facts,.c2hero-facts'), buy);
      move(buy.querySelector('.pdp2-buy__flavour,.elite2-description,.c2hero-description'), buy.querySelector('.ze-purchase-actions') || buy.querySelector('product-form'));
    }
    const apply = () => {
      moves.forEach(({node,marker,after}) => (mobile.matches ? after : marker).after(node));
      window.dispatchEvent(new Event('scroll'));
    };
    apply();
    mobile.addEventListener('change', apply);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => requestAnimationFrame(init), {once:true});
  else requestAnimationFrame(init);
})();
